module.exports = __webpack_public_path__ + "static/media/ic-configuration.553fd12f.svg";